import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, Icon, ListView, WingBlank, WhiteSpace } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import '../styles/DeviceLogPage.css'

const history = require("history").createHashHistory()

class DeviceLogPage extends Component {
    static defaultProps = {
        fetchLogs: (params, callback) => {}
    }

    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4
        };
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 80;
        this.setState({
            height
        })
        this.loadPageData(1)
    }

    loadPageData = (pageNum) => {
        const params = {
            pageNum,
            pageSize: 20,
        }
        this.props.fetchLogs(params, (resp) => {
            let data = resp.data
            this.pageNum = data.pageNum;
            this.pageSize = data.pageSize;
            this.pages = data.pages;
            let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : {}
            this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
            this.setState({
                dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                isLoading: false,
                hasMore: this.pageNum < this.pages,
            })
        })
    }

    onEndReached = (event) => {
        if (this.state.isLoading || !this.state.hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadPageData(++this.pageNum)
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.map((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
            return data;
        })
        return rowDatas;
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    renderRow = (rowData, sectionId, rowId) => {
        return (
            <WingBlank size='sm' key={rowId}>
                <div className='row'>
                    <div className='icon'>
                        <i className={`iconfont ${rowData.online===1?'icon-zaixian':'icon-lixian'}`} style={{color: `${rowData.online===1?'#04bbc5':'orange'}`}}/>
                    </div>
                    <div className='info'>
                        <div className='description'>
                            <span>{rowData.online===1?'上线':'断线'}</span>
                        </div>
                        <div className='time'>{rowData.createTime}</div>
                    </div>
                </div>
            </WingBlank>
        )
    }

    render() {
        const {dataSource, isLoading, height } = this.state;
        return (
            <div className='device-log-page'>
                <NavBar mode="light" className='fixed' icon={<Icon type="left" color="black" size="md"/>} onLeftClick={history.goBack}>设备日志</NavBar>
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => {this.renderFooter(isLoading)}}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: height,
                        overflow: 'auto',
                        paddingTop: 50
                    }}
                />
            </div>
        )
    }
}

export default DeviceLogPage;


// WEBPACK FOOTER //
// ./src/components/DeviceLogPage.js